function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavRight = function SvgNavRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 35 35"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33.7c-8.4 0-16.2-7.8-16.2-16.2H.5c0 9.4 7.6 17 17 17zm16.2-16.2c0 8.4-7.8 16.2-16.2 16.2v.8c9.4 0 17-7.6 17-17zM17.5 1.3c8.4 0 16.2 7.8 16.2 16.2h.8c0-9.4-7.6-17-17-17zm0-.8C8.1.5.5 8.1.5 17.5h.8c0-8.4 7.8-16.2 16.2-16.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.1 14.3 3.7 3.7-3.7 3.7",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.7095,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 3.7838
    }
  }));
};
export default SvgNavRight;